import { z } from 'zod'

import {
  DateZod,
  PiloteInstitutionRecordZod,
  PilotePersonRecordZod,
  PiloteTransportRequestRecordZod,
} from '../../common'
import { PiloteTeamMemberRecordZod, PiloteTeamRecordZod, PiloteTeamVolunteerRecordZod } from '../../teams'

export const PiloteTransportRequestZod = z.object({
  timestamp: DateZod.nullable().optional(),
  transport_request: PiloteTransportRequestRecordZod,
  institution: PiloteInstitutionRecordZod.nullable(),
  team: PiloteTeamRecordZod.nullable(),
  escort: PiloteTeamMemberRecordZod.nullable(),
  escort_volunteer: PiloteTeamVolunteerRecordZod.nullable(),
  escort_person: PilotePersonRecordZod.nullable(),
  driver: PiloteTeamMemberRecordZod.nullable(),
  driver_volunteer: PiloteTeamVolunteerRecordZod.nullable(),
  driver_person: PilotePersonRecordZod.nullable(),
  partner: PiloteTeamMemberRecordZod.nullable(),
  partner_volunteer: PiloteTeamVolunteerRecordZod.nullable(),
  partner_person: PilotePersonRecordZod.nullable(),
})
